import { c as _c } from "react/compiler-runtime";
import { useIntl } from '@onefootprint/hooks';
import type { ProxyConfigBasic } from '@onefootprint/request-types/dashboard';
import { Badge, CodeInline } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import Actions from './components/actions';
export type RowProps = {
  proxyConfig: ProxyConfigBasic;
};
const Row = t0 => {
  const $ = _c(32);
  const {
    proxyConfig
  } = t0;
  const {
    t
  } = useTranslation("vault-proxy");
  const {
    formatDateWithTime
  } = useIntl();
  const {
    name,
    id,
    url,
    method,
    status,
    createdAt
  } = proxyConfig;
  let t1;
  if ($[0] !== name) {
    t1 = <td>{name}</td>;
    $[0] = name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== id) {
    t2 = <td><CodeInline>{id}</CodeInline></td>;
    $[2] = id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== url) {
    t3 = <td>{url}</td>;
    $[4] = url;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== method) {
    t4 = <td>{method}</td>;
    $[6] = method;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== status || $[9] !== t) {
    t5 = status === "enabled" && <Badge variant="success">{t(_temp)}</Badge>;
    $[8] = status;
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== status || $[12] !== t) {
    t6 = status === "disabled" && <Badge variant="error">{t(_temp2)}</Badge>;
    $[11] = status;
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <td>{t5}{t6}</td>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== createdAt || $[18] !== formatDateWithTime) {
    t8 = formatDateWithTime(new Date(createdAt));
    $[17] = createdAt;
    $[18] = formatDateWithTime;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t8) {
    t9 = <td>{t8}</td>;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== proxyConfig) {
    t10 = <td aria-label="actions"><Actions proxyConfig={proxyConfig} /></td>;
    $[22] = proxyConfig;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t1 || $[25] !== t10 || $[26] !== t2 || $[27] !== t3 || $[28] !== t4 || $[29] !== t7 || $[30] !== t9) {
    t11 = <>{t1}{t2}{t3}{t4}{t7}{t9}{t10}</>;
    $[24] = t1;
    $[25] = t10;
    $[26] = t2;
    $[27] = t3;
    $[28] = t4;
    $[29] = t7;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
};
export default Row;
function _temp($) {
  return $.status.enabled;
}
function _temp2($_0) {
  return $_0.status.disabled;
}